import { createSelector } from "reselect";

import getSelection from "../base_getters/get_selection";

const getInspectionMode = createSelector([
  getSelection
], (selection) => selection.inspectionMode );

export default getInspectionMode;
